var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgScanTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 317,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 291v20a5 5 0 005 5h20M257 291v20a5 5 0 01-5 5h-20M1 26V6a5 5 0 015-5h20M257 26V6a5 5 0 00-5-5h-20",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgImgScanTarget;